<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      default: '',
    },
    select: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      default: 'filter',
    },
  },
  data() {
    return {
      inputValue: this.value,
    }
  },
  computed: {
    activeItem() {
      let active = false;

      if(this.value === this.inputValue) {
        this.select.forEach(item => {
          if(item.value === this.value) {
            active = item
          }
        });
      }

      return active !== false ? active : this.select[0];
    },
  },
  watch: {
    value(v) {
      this.inputValue = v;
    },
    inputValue(v) {
      this.$emit('input', v);
      this.$emit('change', v, this.name);
    },
  },
  mounted() {
    this.getValue();
  },
  methods: {
    getValue() {
      this.inputValue = this.$route.query[this.name] || this.value;
    }
  },
}
</script>
<template>
  <b-dropdown aria-role="list">
    <b-button
      slot="trigger"
      type="is-primary is-filter-style has-icons-left is-small"
      rounded
      outlined
    >
      <BaseIcon :name="icon" class-name="filter-icon" />
      <span class="filterText">{{activeItem.text}}</span>
    </b-button>
    <b-dropdown-item
      v-for="(selectItem, index) in select"
      :key="index"
      aria-role="listitem"
      :class="{ 'is-active': selectItem.value === activeItem.value}"
      @click="inputValue = selectItem.value"
    >
      {{selectItem.text}}
    </b-dropdown-item>
  </b-dropdown>
</template>

<style lang="scss" module>

</style>
